/**
 * Утилиты для работы с призванными существами
 */

/**
 * Определяет информацию для отображения призванного существа
 * @param {Object} panel - Панель существа
 * @param {Array} panels - Массив всех панелей
 * @returns {Object|null} Информация для отображения или null
 */
export function resolveSummonDisplay(panel, panels) {
  if (!panel?.isSummon) {
    return null;
  }
  const info = panel.summonInfo || {};
  const ownerPanel = info.ownerId != null ? panels.find(item => item.id === info.ownerId) : null;
  const ownerName = ownerPanel?.name || (info.ownerId != null ? `#${info.ownerId}` : null);
  const tags = Array.isArray(info.tags) ? info.tags : [];
  const isClone = Boolean(tags.includes('iso_clone') || panel.raw?.metadata?.isoMirrorClone || tags.includes('fork_clone') || panel.raw?.metadata?.forkClone);
  const badgeLabel = isClone ? 'CLONE' : 'SUMMON';
  const tooltipParts = [];
  if (ownerName) {
    tooltipParts.push(`Источник: ${ownerName}`);
  }
  if (info.abilityId) {
    tooltipParts.push(`Способность: ${info.abilityId.replace(/_/g, ' ')}`);
  }
  if (info.createdAt != null) {
    tooltipParts.push(`Раунд призыва: ${info.createdAt}`);
  }
  return {
    badgeLabel,
    ownerName,
    tooltip: tooltipParts.join('\n')
  };
}



